module.exports = __webpack_public_path__ + "20250721160708/img/head_img.34ce4da8.png";